module.exports = __webpack_public_path__ + "static/img/product3.0208640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/clean/product3.png
// module id = T+wd
// module chunks = 0